// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
// Helper function to generate a random password
export var generateRandomPassword = function (length) {
    if (length === void 0) { length = 12; }
    var charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_.";
    var charsetLength = charset.length;
    // Array to hold random values
    var randomValues = new Uint8Array(length);
    // Fill array with secure random values
    crypto.getRandomValues(randomValues);
    var password = "";
    for (var i = 0; i < length; i++) {
        // Map random value to charset index
        password += charset[randomValues[i] % charsetLength];
    }
    return password;
};
